import { FC } from 'react';

import {
	BUTTON_TYPES,
	ErrorIcon,
	EvBodyDefault,
	EvButton,
	EvFlexColumn,
	EvFlexRow,
	EvHeadingLarge,
	EvIcon
} from '@evinced-private/ui-common';

interface IErrorStateProps {
	message: string;
	onRetry?: () => void;
}

export const ErrorState: FC<IErrorStateProps> = ({ message, onRetry }: IErrorStateProps) => {
	return (
		<EvFlexColumn>
			<EvFlexRow align="CENTER" justify="CENTER">
				<EvIcon icon={ErrorIcon} />
				<EvHeadingLarge as="h2">Something went wrong</EvHeadingLarge>
			</EvFlexRow>
			<EvFlexColumn align="CENTER" justify="CENTER">
				<EvBodyDefault as="p">{message}</EvBodyDefault>
				{onRetry && (
					<EvButton type={BUTTON_TYPES.PRIMARY} onClick={onRetry}>
						Try Again
					</EvButton>
				)}
			</EvFlexColumn>
		</EvFlexColumn>
	);
};
